import { render } from "./WhatOurClientsSaying.vue?vue&type=template&id=0e232691"
import script from "./WhatOurClientsSaying.vue?vue&type=script&lang=js"
export * from "./WhatOurClientsSaying.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\77460\\Desktop\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__